import { Ranking } from '../ranking/Ranking';

/**
 * Class representing a commitment ranking.
 * @extends Ranking
 * @abstract
 */
export class CommitmentRanking extends Ranking {}
